<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            xl="10"
            offset-xl="1"
          >
            <v-row
              class="pb-5"
            >
              <v-col
                cols="12"
                md="6"
                lg="6"
                :class="$vuetify.breakpoint.lgAndUp?'pr-4':''"
              >
                <p
                  class="display-2 font-weight-thin primary--text text--darken-1"
                  v-text="$t('nav.contact')"
                />
                <div
                  class="text-justify subheading"
                  v-html="$t('contact.intro')"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                xl="5"
                offset-xl="1"
              >
                <v-card raised>
                  <v-img
                    height="350"
                    tile
                    src="@/static/img/AAs.jpeg"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>

    <v-container
      class="px-0"
      fluid
    >
      <v-row
        class="grey lighten-4"
        no-gutters
      >
        <v-col
          class="pt-2 pb-3"
          cols="12"
          md="6"
          lg="5"
          offset-lg="1"
        >
          <v-container>
            <v-row>
              <v-col
                class="pt-4"
                cols="12"
              >
                <p
                  class="headline grey--text text--darken-2"
                  v-html="$t('contact.details.header')"
                />
                <p v-html="$t('contact.details.intro')" />
              </v-col>
              <v-col cols="12">
                <contact-data :language="language" />
              </v-col>
              <v-col cols="12">
                <p v-html="$t('contact.details.collaborations')" />
              </v-col>
              <v-col
                v-for="c in collaborators"
                :key="c.alt"
                class="pa-2"
                cols="6"
                sm="4"
                lg="3"
              >
                <v-card
                  :href="c.site"
                  target="_BLANK"
                  height="60px"
                  class="pa-2"
                  :color="c.bg"
                >
                  <v-img
                    :src="c.logo"
                    :alt="c.alt"
                    contain
                    height="45px"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="6"
          lg="5"
          offset-lg="1"
        >
          <gmap-map
            :center="{lat:52.3347279, lng:4.8617824}"
            :zoom="16"
            style="width: 100%; height: 100%; min-height: 300px"
          >
            <gmap-marker :position="{lat:52.3347279, lng:4.8617824}" />
          </gmap-map>
        </v-col>
      </v-row>
    </v-container>
    <v-col cols="12">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            xl="10"
            offset-xl="1"
          >
            <p
              class="headline pt-4 grey--text text--darken-2"
              v-text="$t('contact.members')"
            />
            <v-row>
              <v-col
                v-for="(contact, i) in contacts"
                :key="i"
                cols="10"
                offset="1"
                sm="4"
                offset-sm="0"
                md="3"
                xl="2"
              >
                <aa-member :contact="contact" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import { getBreadcrumbSchema } from '../assets/js/util'

import ContactData from '@/components/ContactData'
import AaMember from '@/components/AaMember'
import contacts from '@/content/contact/contactList.json'
import collaborators from '@/assets/json/collaborators.json'

export default {
  components: {
    AaMember, ContactData
  },
  data() {
    return {
      contacts: contacts.filter(ctc => !ctc.hideInMembers),
      collaborators
    }
  },
  computed: {
    language () {
      return this.$i18n.locale
    }
  },
  head () {
    const title = 'Contact'
    return {
      title,
      script: [{
        innerHTML: JSON.stringify({
          '@context': 'http://schema.org',
          '@type': 'Organization',
          'url': 'https://attentionarchitects.com',
          'name': 'Attention Architects',
          'logo': 'https://attentionarchitects.com/img/services/eye.jpg',
          'contactPoint': {
            '@type': 'ContactPoint',
            'telephone': '+31 6 4625 8151',
            'email': 'info@attentionarchitects.com',
            'contactType': 'Customer service'
          }
        }),
        type: 'application/ld+json'
      },
      getBreadcrumbSchema(this.$route.path, title)
      ]
    }
  }
}
</script>

<style scoped>
.button-logo {
  max-height: 100%;
  max-width: 100%
}
</style>